

export const USER = "/users";
export const COMMON = '/common'
export const DASHBOARD='/dashboard'
export const TICKET = '/tickets';
export const CLIENTS = "/clients";
